/*
 * @license
 * Copyright Ahmed Elywa. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { styled } from '@styles';
import { css } from 'styled-components';

export const TabsWrapper = styled.div`
  display: block;
`;

export const Tab = styled.li`
  ${({ theme }) => css`
    cursor: pointer;
    // margin-bottom: -1px;
    text-align: center;
    position: relative;
    text-transform: uppercase;
    &.active a::before {
      display: block;
    }
    a {
      padding-left: ${({ theme: { spacing } }) => spacing.gutter};
      padding-right: ${({ theme: { spacing } }) => spacing.gutter};
      display: flex;
      align-items: center;
      position: relative;
      text-decoration: none;

      &::before {
        display: none;
        position: absolute;
        content: '';
        width: 100%;
        border-radius: 3px;
        bottom: -2px;
        left: 0;
        background-color: ${theme.colors.red};
        height: 2px;
      }
    }

    &.active {
      a {
        color: ${theme.colors.red};
      }
    }
    &.disabled {
      & > * {
        opacity: 0.5;
      }
      cursor: default;
      pointer-events: none;
      a {
        cursor: default;
        pointer-events: none;
      }
    }
  `}
`;

export const Tabs = styled.ul<{ fullWidth: boolean }>`
  ${({ theme, fullWidth }) => css`
    display: flex;
    flex-direction: row;
    list-style-type: none;
    align-items: center;
    margin: 0;
    padding: 0;
    ${fullWidth && 'justify-content: space-around;'}
    ${!fullWidth && 'justify-content: center;'}
  `}
`;

export const Content = styled.div`
  flex: 1;
  -ms-flex: 1 1 auto;
  overflow: auto;
  background-color: ${(props) => props.theme.colors.light};
  padding: 2em;
`;
